import React, { createContext, useContext, useCallback } from 'react';
import hotToast from 'react-hot-toast';

const ToastContext = createContext(null);

export function useToast() {
  const ctx = useContext(ToastContext);

  const showToast = useCallback((msg, type = 'success') => {
    hotToast.dismiss(); // dismiss previous to ensure only one toast appears
    if (type === 'error') hotToast.error(msg);
    else if (type === 'success') hotToast.success(msg);
    else hotToast(msg);
  }, []);

  const toastFn = useCallback((typeOrTitle, titleOrDesc, desc) => {
    hotToast.dismiss(); // dismiss previous to ensure only one toast appears
    if (desc) {
      // toast('success', 'Title', 'Description')
      const msg = `${titleOrDesc} — ${desc}`;
      if (typeOrTitle === 'error') hotToast.error(msg);
      else if (typeOrTitle === 'info') hotToast(msg, { icon: 'ℹ️' });
      else hotToast.success(msg);
    } else if (titleOrDesc) {
      // toast('success', 'Message')
      if (typeOrTitle === 'error') hotToast.error(titleOrDesc);
      else if (typeOrTitle === 'info') hotToast(titleOrDesc, { icon: 'ℹ️' });
      else hotToast.success(titleOrDesc);
    } else {
      hotToast.success(typeOrTitle);
    }
  }, []);

  toastFn.success = (msg) => { hotToast.dismiss(); hotToast.success(msg); };
  toastFn.error = (msg) => { hotToast.dismiss(); hotToast.error(msg); };
  toastFn.info = (msg) => { hotToast.dismiss(); hotToast(msg, { icon: 'ℹ️' }); };

  if (ctx) {
    return ctx;
  }

  return {
    showToast,
    toast: toastFn,
  };
}

export function ToastProvider({ children }) {
  const { showToast, toast } = useToast();

  return (
    <ToastContext.Provider value={{ showToast, toast }}>
      {children}
    </ToastContext.Provider>
  );
}

export default ToastProvider;
